import React from "react";
class Logo extends React.Component {
  render() {
    return (
      <a href = "https://akular.com/">
      <svg
        style={{ float: "left", height: "28px",padding: "10px" }}
        viewBox="0 0 460 45"
        xmlns="http://www.w3.org/2000/svg"
        data-type="color"
        role="img"
        preserveAspectRatio="xMidYMid meet"
      >
        <g>
          <path
            class="cls-1"
            d="M299.48,53.63H289.22c-.26,0-.39-.12-.39-.38V39.43a.34.34,0,0,1,.39-.39h10.26c5.1,0,8.14,2.71,8.14,7.3s-3,7.29-8.14,7.29m14.21,24c.45,0,.64-.39.38-.78l-9.36-18.53a11.94,11.94,0,0,0,8.65-11.94c0-7.62-5.55-12.66-13.75-12.66H283.73a.61.61,0,0,0-.65.65V76.94a.61.61,0,0,0,.65.65h4.45a.61.61,0,0,0,.65-.65V59.38a.34.34,0,0,1,.39-.39h9.68l8.78,17.95c.2.45.39.65.84.65Z"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M195.25,77.05h18.08a.58.58,0,0,0,.48-.19.67.67,0,0,0,.16-.45V74.28a.66.66,0,0,0-.16-.49.68.68,0,0,0-.48-.16H195.25a.73.73,0,0,0-.45.16.6.6,0,0,0-.19.49v2.13a.65.65,0,0,0,.64.64m-7.1,0h2.39a.59.59,0,0,0,.48-.19.67.67,0,0,0,.16-.45V33.8a.66.66,0,0,0-.16-.49.65.65,0,0,0-.48-.16h-2.39a.67.67,0,0,0-.45.16.6.6,0,0,0-.2.49V76.41a.62.62,0,0,0,.2.45.61.61,0,0,0,.45.19"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M47.5,65.5H62.35a.7.7,0,0,0,.42-.13.4.4,0,0,0,.16-.32l-.06-.26-.78-2.13a.75.75,0,0,0-.77-.52H48.66m60.56,14.91h2.91c.26,0,.39-.12.39-.38l0-.13s0-.13-5-8.68L99.6,54.13a.55.55,0,0,0-.45-.32.71.71,0,0,0-.45.26l-1.55,1.87a.69.69,0,0,0-.19.52,1.13,1.13,0,0,0,.12.39l11.24,19.56a1.37,1.37,0,0,0,.39.52,1,1,0,0,0,.51.12M90.24,59l21.11-25.12a.45.45,0,0,0,.1-.48.4.4,0,0,0-.42-.23h-3a1.07,1.07,0,0,0-.55.13,2.48,2.48,0,0,0-.55.52L89.79,54.59a1.38,1.38,0,0,0-.32.77v3.36c0,.34.1.51.32.51a.55.55,0,0,0,.45-.25M71.32,77.05h2.52a.57.57,0,0,0,.39-.12.49.49,0,0,0,.13-.33l-.07-.19L59.06,33.8a.78.78,0,0,0-.78-.65H56a.6.6,0,0,0-.42.13.46.46,0,0,0-.16.39l.06.25L70.55,76.54a.75.75,0,0,0,.77.51"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M25,59.4a3.77,3.77,0,1,0-3.76-3.76A3.76,3.76,0,0,0,25,59.4"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M335.09,59.4a3.77,3.77,0,1,0-3.76-3.76,3.76,3.76,0,0,0,3.76,3.76"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M151,77.57A13.15,13.15,0,0,0,160.27,73q3.22-4,3.23-11.07V33.79a.65.65,0,0,0-.17-.48.63.63,0,0,0-.48-.16h-2.39a.67.67,0,0,0-.45.16.59.59,0,0,0-.19.48V61.88q0,5.43-2.3,8.52a9.58,9.58,0,0,1-6.61,3.75.59.59,0,0,0-.59.64V77a.57.57,0,0,0,.17.42.54.54,0,0,0,.42.16Zm-4.77,0a.49.49,0,0,0,.45-.1.58.58,0,0,0,.19-.48v-2.2a.58.58,0,0,0-.58-.64,9.86,9.86,0,0,1-6.62-3.78q-2.3-3.06-2.29-8.49V33.79a.57.57,0,0,0-.64-.64h-2.39a.68.68,0,0,0-.46.16.62.62,0,0,0-.19.48V61.88Q133.73,69,137,73a13,13,0,0,0,9.27,4.58"
            transform="translate(-21.21 -33.15)"
          />
          <path
            class="cls-1"
            d="M240.41,62.09l7-20h.13l6.91,20Zm-11,14.85c-.12.39.07.65.46.65h4.52c.38,0,.64-.19.84-.65l3.35-9.55h17.76l3.36,9.55a.77.77,0,0,0,.84.65H265a.44.44,0,0,0,.45-.65l-15-42.61a.83.83,0,0,0-.84-.65h-4.19c-.46,0-.65.26-.78.65Z"
            transform="translate(-21.21 -33.15)"
          />
        </g>
      </svg>
      </a>
    );
  }
}

export default Logo;
